module.exports = __webpack_public_path__ + "img/header__logo——zh.f4ee204d.png";